import StarHalfIcon from '@mui/icons-material/StarHalf';
import {getRating} from '../../utils/helper';
import Chip from '@mui/material/Chip';
import * as React from 'react';
import Box from '@mui/material/Box';

export default function RatingChip() {
  const rating = getRating()
  const color = rating >= 4 ? 'success' : 'warning'
  return <Box>
    <Chip size="small" icon={<StarHalfIcon/>}
          color={color}
          label={rating} variant="filled"/>
  </Box>
}